import {
    TelemetryChannel,
    TelemetryType,
  } from '@tableau/microview-communication-service/lib/src/channelDefinitions/TelemetryChannelDefinitions';

import { ExplorerSortEvent, SearchResultClickedEvent,TelemetryEvents } from '~src/common/telemetryEvents/TelemetryEvents';
import { Telemetry, ValidTelemetryEvent } from '~src/commonInfra/services/Telemetry';
import { FiltersEvents, FiltersUpdatedEvent } from '~src/spacesPlatform/components/Explorer/helpers/FilterUpdater';

import { searchTelemetry } from '../components/SearchTelemetry';

export function startListening(): () => void {
    const telemetryEvent = new TelemetryChannel();

    const stopListeningToTelemetryEventChannel = telemetryEvent.listen((r) => {
        switch (r.type) {
            case TelemetryType.ClickSearchResult:
                return sendSearchResultClickedEvent(r.bag as Omit<SearchResultClickedEvent, 'searchFlowId'>);
            case TelemetryType.FilterSearch:
                return sendFiltersUpdatedEvent(r.bag as FilterTelemetryEvent);
            case TelemetryType.SortSearch:
                return sendSortEvent(r.bag as SortTelemetryEvent);
            default:
                return null;
        }
    });

    const sendSearchResultClickedEvent = (event: Omit<SearchResultClickedEvent, 'searchFlowId'>) => {
        const result: Omit<SearchResultClickedEvent, 'searchFlowId'> = {
            type: TelemetryEvents.SearchResultClicked,
            eventSource: event.eventSource,
            resultType: event.resultType,
            seeAll: event.seeAll,
            index: event.index,
            total: event.total,
            searchTerm: event.searchTerm,
            contentId: event.contentId,
        };
        return searchTelemetry.sendSearchResultClickedEvent(result);
    };

    const sendFiltersUpdatedEvent = (event: FilterTelemetryEvent)=> {
        const telemetryEvent = {
            type: FiltersEvents.FiltersUpdated,
            space: 'search',
            subspace: event.pageType, //single or mixed page type
            contentType: event.contentType,
            ...(event.added) && { filtersAdded: event.added },
            ...(event.removed) && { filtersRemoved: event.removed },
            ...(event.updated) && { filtersUpdated: event.updated },
          } as ValidTelemetryEvent<FiltersUpdatedEvent>;
        return Telemetry.sendEvent<FiltersUpdatedEvent>(telemetryEvent);
    };

    const sendSortEvent = (event: SortTelemetryEvent) => {
        const telemetryEvent = {
            type: TelemetryEvents.ExplorerSort,
            space: 'search',
            subspace: event.pageType, //single or mixed page type
            contentType: event.contentType,
            sortField: event.field,
            ascending: event.ascending,
            eventSource: event.eventSource,
          } as ValidTelemetryEvent<ExplorerSortEvent>;
        return Telemetry.sendEvent<ExplorerSortEvent>(telemetryEvent);
    };

    return () => {
        stopListeningToTelemetryEventChannel();
    };
}
interface FilterTelemetryEvent {
    pageType: string;
    contentType: string;
    added?: string;
    removed?: string;
    updated?: string;
}
interface SortTelemetryEvent {
    pageType: string;
    contentType: string;
    field: string;
    ascending: boolean;
    eventSource: string;
}
